import styles from "../../assets/styles/AppHome/BusinessInsightCard.module.scss";
import { BusinessInsightComponent as BIC } from "../../components/Home";
import { businessStore, userStore } from "../../stores";
import { amountFormatter } from "../../utils/utils";
import React, { useState } from "react";
import { MimaText } from "../../components";
import { MdKeyboardArrowDown } from "react-icons/md";
import { AnimatePresence, motion } from "framer-motion";

const BusinessInsightCard = ({
  transactionsSummary,
  sales,
  setCurr2,
  filterPeriod,
}) => {
  const [curr, setCurr] = useState(
    `${businessStore.defaultCurrency ? businessStore.defaultCurrency : transactionsSummary[0]?.currencyCode}`
  );
  const [showCurr, setShowCurr] = useState(false);

  return (
    <div className={styles.bi}>
      <div className={styles.bi__title}>
        <h4 className={styles.bi__title_text}>Financial Insights</h4>

        {transactionsSummary.length > 1 ? (
          <div className={styles.selectCurrency__text}>
            <MimaText
              variant="small"
              color="var(--color-fash-primary-3)"
              style={{ paddingTop: ".5rem" }}
              width={12}
            >
              Click arrow for other currencies
            </MimaText>

            <div className={styles.selectCurrency}>
              <div
                className={
                  !showCurr
                    ? styles.selectCurrency__icon
                    : styles.selectCurrency__icon_active
                }
                onClick={() => {
                  setShowCurr(!showCurr);
                }}
              >
                <MdKeyboardArrowDown />
              </div>

              <AnimatePresence>
                {showCurr && (
                  <motion.div
                    initial={{
                      opacity: 0,
                      scaleY: 0,
                    }}
                    animate={{
                      scaleY: 1,
                      opacity: 1,
                      transition: {
                        duration: 0.2,
                      },
                    }}
                    exit={{
                      scaleY: 0,
                      opacity: 0,
                      transition: {
                        duration: 0.2,
                      },
                    }}
                    style={{ originY: 0 }}
                    className={styles.selectCurrency__list}
                  >
                    {transactionsSummary.map((item) => (
                      <li
                        key={item.currencyCode}
                        className={
                          curr === item.currencyCode
                            ? styles.selectCurrency__list_active
                            : ""
                        }
                        onClick={() => {
                          setCurr(item.currencyCode);
                          setCurr2(item.currencyCode);
                          setShowCurr(false);
                        }}
                      >
                        {item.currencyCode}
                      </li>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <>
        {transactionsSummary.length === 0 ? (
          <div>
            <MimaText color="var(--color-fash-primary-3)" mb={1}>
              Insights for {filterPeriod} transactions{" "}
            </MimaText>
            <div className={styles.bi__content}>
              <BIC
                title="Total Inflow"
                amount={0}
                styleClass={styles.bi__income}
              />
              {userStore.user.accountType === "Business" ? (
                <>
                  <BIC
                    title={
                      businessStore.business?.businessCategory?._id.toString() !==
                      "63b2fe5e02431e63871e33f4"
                        ? "Total Profit"
                        : "Balance"
                    }
                    amount={0}
                  />
                  <BIC title="Outstanding Balance" amount={0} />
                </>
              ) : (
                ""
              )}
              <BIC title="Total Outflow" amount={0} />
              <BIC title="Debt" amount={0} />
              {userStore.user.accountType === "Business" ? (
                <BIC title="Accrued Value Added Tax(VAT)" amount={0} />
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <>
            {transactionsSummary
              .filter((x) => {
                return x.currencyCode === curr;
              })
              .map((summary, i) => (
                <div key={i}>
                  <MimaText color="var(--color-fash-primary-3)" mb={1}>
                    Insights for {summary.currencyCode} transactions{" "}
                  </MimaText>
                  <div className={styles.bi__content}>
                    <BIC
                      title="Total Inflow"
                      amount={amountFormatter(summary.currencyCode).format(
                        summary.totalIncome || 0
                      )}
                      styleClass={styles.bi__income}
                    />
                    {userStore.user.accountType === "Business" ? (
                      <>
                        <BIC
                          title="Total Profit"
                          amount={amountFormatter(summary.currencyCode).format(
                            parseInt(summary.totalIncome || 0, 10) -
                              parseInt(summary.totalExpenses || 0, 10)
                          )}
                        />
                        <BIC
                          title="Outstanding Balance"
                          amount={amountFormatter(summary.currencyCode).format(
                            summary.totalExpectedBalance || 0
                          )}
                        />
                      </>
                    ) : (
                      ""
                    )}
                    <BIC
                      title="Total Outflow"
                      amount={amountFormatter(summary.currencyCode).format(
                        summary.totalExpenses || 0
                      )}
                    />
                    <BIC
                      title="Debt"
                      amount={amountFormatter(summary.currencyCode).format(
                        summary.totalAmountOwed || 0
                      )}
                    />
                    {userStore.user.accountType === "Business" ? (
                      <BIC
                        title="Accrued Value Added Tax(VAT)"
                        amount={amountFormatter(summary.currencyCode).format(
                          summary.totalVAT || 0
                        )}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
          </>
        )}
      </>
    </div>
  );
};

export default BusinessInsightCard;
